import React from 'react'
import "./product-add.css";
import { Button, Card, Col, Form , Input, Row, Space } from "antd"
import ImageUpload from '../components/ImagesUpload';
import DescEditor from '../components/DescEditor';

const AddProductNewFragment = () => {
  return (
    <div className='product-add-container'>
      
      <div className='product-add-wrapper'>

        <div className='main-listing'>
          <Card bodyStyle={{ paddingBottom:0 }} className='add-layout-card'>
            <Form layout='vertical'>
              <Form.Item label='Title'>
                  <Input placeholder="your product name" />
              </Form.Item>
              <Form.Item placeholder="Description">
                <DescEditor />
              </Form.Item>
            </Form>
          </Card>

          <Card bodyStyle={{ paddingBottom:0 }} title="Media" className='add-layout-card'>
            <Form layout='vertical'>
              <Form.Item >
                  <ImageUpload />
              </Form.Item>
            </Form>
          </Card>

          <Card bodyStyle={{ paddingBottom:0 }} title="Pricing" className='add-layout-card'>
            <Row gutter={[8,8]}>
              <Col span={12}>
                <Form layout='vertical'>
                  <Form.Item label="Sale Price">
                      <Input  placeholder='0' />
                  </Form.Item>
                </Form>
              </Col>
              <Col span={12}>
                <Form layout='vertical'>
                  <Form.Item label="Discount Price">
                      <Input  placeholder='0' />
                  </Form.Item>
                </Form>
              </Col>
            </Row>
          </Card>

          <Card bodyStyle={{ paddingBottom:0 }} title="Inventory" className='add-layout-card'>
            <Row gutter={[8,8]}>
              <Col span={12}>
                <Form layout='vertical'>
                  <Form.Item label="Stock Qty">
                      <Input  placeholder='0' />
                  </Form.Item>
                </Form>
              </Col>
              <Col span={12}>
                <Form layout='vertical'>
                  <Form.Item label="SKU">
                      <Input  placeholder='0' />
                  </Form.Item>
                </Form>
              </Col>
            </Row>
          </Card>

          <Card bodyStyle={{ paddingBottom:0 }} title="Shipping" className='add-layout-card'>
            <Row gutter={[8,8]}>
              <Col span={12}>
                <Form layout='vertical'>
                  <Form.Item label="Weight">
                      <Input  placeholder='0' />
                  </Form.Item>
                </Form>
              </Col>
              <Col span={12}>
                <Form layout='vertical'>
                  <Form.Item label="Dangourus Goods">
                      <Input  placeholder='0' />
                  </Form.Item>
                </Form>
              </Col>
            </Row>
          </Card>

        </div>

        <div className='optional-listing'>
          <Card bodyStyle={{ paddingBottom:0 }} className='add-layout-card'>
            <Form layout='vertical'>
              <Form.Item label='Title'>
                  <Input placeholder="your product name" />
              </Form.Item>
              <Form.Item placeholder="Description">
                <Input placeholder="your product name" />
              </Form.Item>
            </Form>
          </Card>

          <Card bodyStyle={{ paddingBottom:0 }} title="Variants" className='add-layout-card'>
            <Form layout='vertical'>
              <Form.Item label="Price">
                  <Input  placeholder='0' />
              </Form.Item>
            </Form>
          </Card>

        </div>

        <hr/>

        <Space />

        <div className='product-add-action'>
          <Button type='primary'>Save</Button>
        </div>
        <Space />
        <br/>

      </div>

      


    </div>
  )
}

export default AddProductNewFragment